import { writable } from 'svelte/store'
import type { Writable } from 'svelte/store'
import type { WalletSummary } from '@/components/appDriver/wallet/types'

export const cachedWalletSummary: Writable<WalletSummary | null> = writable(null)

export function setCachedWalletSummary(summary: WalletSummary): void {
  cachedWalletSummary.set(summary)
}
